import React, { useState, useEffect } from 'react';
import { getApiUrl } from './apiConfig';

export default function CallCenter({ onBackClick }) {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [statusMessage, setStatusMessage] = useState('');
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        let lastWidth = window.innerWidth;
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            // Only update if viewport width actually changed (prevents re-renders on mobile address bar hide/show)
            if (Math.abs(currentWidth - lastWidth) > 5) {
                lastWidth = currentWidth;
                setWindowWidth(currentWidth);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleBack = () => {
        if (onBackClick) {
            onBackClick('home');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form
        if (!formData.name || !formData.email || !formData.message) {
            setStatusMessage('⚠️ Please fill in all fields.');
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setStatusMessage('⚠️ Please enter a valid email address.');
            return;
        }

        setStatusMessage('⏳ Sending message...');

        try {
            const response = await fetch(getApiUrl('contact_api/submit.php'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const text = await response.text();
            console.log('Server response:', text); // Debugging

            let data;
            try {
                data = JSON.parse(text);
            } catch (e) {
                console.error('JSON Parse Error:', e, text);
                setStatusMessage('❌ Error: Could not connect to API. Please check server configuration.');
                return;
            }

            if (data.success) {
                setStatusMessage('✅ ' + data.message);
                setFormData({ name: '', email: '', message: '' });
            } else {
                setStatusMessage('❌ ' + (data.message || 'Failed to send message.'));
            }
        } catch (error) {
            console.error('Fetch Error:', error);
            setStatusMessage('❌ Network Error. Please check your connection or try again later.');
        }

        // Clear message after 5 seconds
        setTimeout(() => setStatusMessage(''), 5000);
    };

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <section className="agripaper-section" aria-label="Contact Us">
            <div className="agripaper-header">
                <button
                    className="back-button"
                    onClick={handleBack}
                    style={{
                        backgroundColor: '#0b6b2f',
                        color: 'white',
                        border: 'none',
                        padding: '10px 20px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '15px',
                        marginBottom: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        fontWeight: '600',
                        transition: 'background-color 0.3s'
                    }}
                    onMouseOver={(e) => e.target.style.backgroundColor = '#085024'}
                    onMouseOut={(e) => e.target.style.backgroundColor = '#0b6b2f'}
                    aria-label="Back to Home"
                >
                    ← ආපසු
                </button>

                <h1 style={{
                    color: '#0b6b2f',
                    fontSize: windowWidth < 768 ? '28px' : '32px',
                    marginBottom: 20,
                    fontWeight: '700',
                    textAlign: 'center' // Centered looks better on all devices
                }}>අප අමතන්න</h1>
                <hr className="footer-sep" style={{ marginBottom: '30px' }} />
            </div>

            <div style={{ maxWidth: '900px', margin: '0 auto', padding: '0 20px' }}>


                {statusMessage && (
                    <div style={{
                        padding: '15px 20px',
                        borderRadius: '8px',
                        marginBottom: '25px',
                        fontWeight: '600',
                        textAlign: 'center',
                        background: statusMessage.includes('✅') ? '#dcfce7' : '#fee2e2',
                        color: statusMessage.includes('✅') ? '#15803d' : '#991b1b',
                        border: `1px solid ${statusMessage.includes('✅') ? '#86efac' : '#fca5a5'}`
                    }}>
                        {statusMessage}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: windowWidth < 768 ? '1fr' : '1fr 1fr',
                        gap: '20px',
                        marginBottom: '20px'
                    }}>
                        <div>
                            <label htmlFor="name" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#555' }}>
                                නම
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '15px',
                                    backgroundColor: '#f9fafb',
                                    transition: 'all 0.3s',
                                    boxSizing: 'border-box'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#0b6b2f';
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.outline = 'none';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#d1d5db';
                                    e.target.style.backgroundColor = '#f9fafb';
                                }}
                                required
                            />
                        </div>

                        <div>
                            <label htmlFor="email" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#555' }}>
                                විදුත් තැපැල් ලිපිනය
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                style={{
                                    width: '100%',
                                    padding: '12px 16px',
                                    border: '1px solid #d1d5db',
                                    borderRadius: '6px',
                                    fontSize: '15px',
                                    backgroundColor: '#f9fafb',
                                    transition: 'all 0.3s',
                                    boxSizing: 'border-box'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#0b6b2f';
                                    e.target.style.backgroundColor = '#fff';
                                    e.target.style.outline = 'none';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#d1d5db';
                                    e.target.style.backgroundColor = '#f9fafb';
                                }}
                                required
                            />
                        </div>
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <label htmlFor="message" style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '600', color: '#555' }}>
                            පණිවිඩය
                        </label>
                        <textarea
                            id="message"
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            rows="6"
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                border: '1px solid #d1d5db',
                                borderRadius: '6px',
                                fontSize: '15px',
                                backgroundColor: '#f9fafb',
                                transition: 'all 0.3s',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                boxSizing: 'border-box'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#0b6b2f';
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.outline = 'none';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = '#d1d5db';
                                e.target.style.backgroundColor = '#f9fafb';
                            }}
                            required
                        />
                    </div>

                    <div style={{ display: 'flex', justifyContent: windowWidth < 768 ? 'center' : 'flex-end', marginBottom: '25px' }}>
                        <button
                            type="submit"
                            style={{
                                backgroundColor: '#0b6b2f',
                                color: 'white',
                                border: 'none',
                                padding: '12px 40px',
                                borderRadius: '6px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                transition: 'all 0.3s',
                                boxShadow: '0 2px 8px rgba(11, 107, 47, 0.3)',
                                width: windowWidth < 768 ? '100%' : 'auto' // Full width button on mobile
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#085024';
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 4px 12px rgba(11, 107, 47, 0.4)';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = '#0b6b2f';
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 2px 8px rgba(11, 107, 47, 0.3)';
                            }}
                        >
                            Send
                        </button>
                    </div>
                </form>
            </div>
        </section >
    );
}